const API_PRESENCE_STATUSES = new Set(['PRESENT', 'COOLING', 'MISSING_FROM_API']);
const ABSENCE_STATUSES = new Set(['COOLING', 'MISSING_FROM_API']);

export const normalizeEnrollmentEvidenceToken = (value) =>
  String(value ?? '')
    .trim()
    .replace(/[\s-]+/g, '_')
    .toUpperCase();

export const isTruthyEnrollmentEvidence = (value) => {
  if (value === true) return true;
  if (value === false || value === null || value === undefined) return false;
  return ['TRUE', 'YES', 'Y', '1'].includes(normalizeEnrollmentEvidenceToken(value));
};

export const isEnrollmentTerminated = (row = {}) =>
  [row?.isTerminated, row?.isTerminatedFlag, row?.terminatedFlag].some(isTruthyEnrollmentEvidence);

const hasSyntheticLifecycleEvidence = (row = {}) => {
  const state = normalizeEnrollmentEvidenceToken(row?.syntheticCancellationState);
  return isTruthyEnrollmentEvidence(row?.syntheticCancellation) ||
    Boolean(state && !['FALSE', 'NO', 'N', '0'].includes(state));
};

export const resolveLifecycleEvidenceValue = (row = {}) =>
  [row?.enrollmentStatusCd, row?.programStatusCd, row?.enrollmentStatus, row?.programStatus]
    .find((value) => value !== null && value !== undefined && String(value).trim() !== '') ?? null;

export const resolveApiPresenceStatus = (row = {}) => {
  const explicit = normalizeEnrollmentEvidenceToken(row?.apiPresenceStatus);
  if (API_PRESENCE_STATUSES.has(explicit)) return explicit;

  const lifecycle = normalizeEnrollmentEvidenceToken(resolveLifecycleEvidenceValue(row));
  const markerBacked = [row?.apiPresenceDerived, row?.missingFromApi].some(isTruthyEnrollmentEvidence);
  const syntheticLifecycle = hasSyntheticLifecycleEvidence(row);
  return ABSENCE_STATUSES.has(lifecycle) && markerBacked && !syntheticLifecycle ? lifecycle : null;
};

export const isLegacyPresenceLifecycleProjection = (row = {}) => {
  const lifecycle = normalizeEnrollmentEvidenceToken(resolveLifecycleEvidenceValue(row));
  const markerBacked = [row?.apiPresenceDerived, row?.missingFromApi].some(isTruthyEnrollmentEvidence);
  const syntheticLifecycle = hasSyntheticLifecycleEvidence(row);
  return markerBacked && !syntheticLifecycle && ABSENCE_STATUSES.has(lifecycle) &&
    resolveApiPresenceStatus(row) === lifecycle;
};

export const resolveEnrollmentLifecycleStatus = (row = {}) => {
  if (isEnrollmentTerminated(row)) return 'TERMINATED';
  if (isLegacyPresenceLifecycleProjection(row)) return null;
  return resolveLifecycleEvidenceValue(row);
};

export { API_PRESENCE_STATUSES, ABSENCE_STATUSES };
